import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import type { SameTenantDupe } from '@onefootprint/request-types/dashboard';
import { CodeInline, LinkButton } from '@onefootprint/ui';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
type DuplicateUserProps = {
  dupe: SameTenantDupe;
};
const DuplicateUser = t0 => {
  const $ = _c(45);
  const {
    dupe
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "duplicateData.drawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== dupe.data) {
    t2 = dupe.data.find(_temp)?.value?.toString();
    $[1] = dupe.data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const firstName = t2;
  const lastInitial = dupe.data.find(_temp2)?.transforms.prefix1;
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp3);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <p className="text-body-2 text-tertiary fp-text">{t3}</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = typeof lastInitial === "string" ? `${lastInitial}.` : "";
  let t6;
  if ($[7] !== firstName || $[8] !== t5) {
    t6 = <p className="text-label-2 text-primary fp-text">{firstName} {t5}</p>;
    $[7] = firstName;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="flex items-center justify-between">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp4);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <p className="text-body-2 text-tertiary fp-text">{t8}</p>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== dupe.fpId) {
    t10 = <CodeInline>{dupe.fpId}</CodeInline>;
    $[17] = dupe.fpId;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="flex items-center justify-between">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t(_temp5);
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <p className="text-body-2 text-tertiary fp-text">{t12}</p>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== dupe.startTimestamp) {
    t14 = format(dupe.startTimestamp, "MM/dd/yy, h:mma").toLowerCase();
    $[26] = dupe.startTimestamp;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <p className="text-label-2 text-primary fp-text">{t14}</p>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t13 || $[31] !== t15) {
    t16 = <div className="flex items-center justify-between">{t13}{t15}</div>;
    $[30] = t13;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t11 || $[34] !== t16 || $[35] !== t7) {
    t17 = <div className="flex flex-col gap-2">{t7}{t11}{t16}</div>;
    $[33] = t11;
    $[34] = t16;
    $[35] = t7;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const t18 = `/users/${dupe.fpId}`;
  let t19;
  if ($[37] !== t) {
    t19 = t(_temp6);
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t18 || $[40] !== t19) {
    t20 = <LinkButton iconPosition="right" iconComponent={IcoArrowTopRight16} href={t18}>{t19}</LinkButton>;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t17 || $[43] !== t20) {
    t21 = <div className="p-4 flex flex-col gap-4 border border-primary rounded">{t17}{t20}</div>;
    $[42] = t17;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
};
export default DuplicateUser;
function _temp(d) {
  return d.identifier === "id.first_name";
}
function _temp2(d_0) {
  return d_0.identifier === "id.last_name";
}
function _temp3($) {
  return $.name;
}
function _temp4($_0) {
  return $_0.fpId;
}
function _temp5($_1) {
  return $_1.createdAt;
}
function _temp6($_2) {
  return $_2.viewUserDetails;
}